
import React, { useState, useEffect, useRef } from "react";

import {  
  MoreVertical,
  CopyPlus,
  ArchiveRestore,
  X,
  ThumbsUp,
  MessageSquare,
} from "lucide-react";


import survayimg1 from "../../assets/img/whatwedo.jpg";
import RedButton from "../RedButton";
import { toast } from 'react-toastify';
import { archiveSurvey, cloneSurvey } from "../../service/mySurvey";
import MySurveyEngagementModal from "./MySurveyEngagementModal";
import MySurveyCommentsThread from "./MySurveyCommentsThread";


const ClosedSurvey = ({ surveys = [], loading, hasMore, onLoadMore, onRefresh, onSwitchTab }) => { 

    const [activeToggleMenu, setActiveToggleMenu] = useState(null);
    const [selectedSurvey, setSelectedSurvey] = useState(null);
    const [showCloneModal, setShowCloneModal] = useState(false);
    const [engagementModalTab, setEngagementModalTab] = useState("likes");
    const [showEngagementModal, setShowEngagementModal] = useState(false);

    const [expandedComments, setExpandedComments] = useState({});

    const toggleComments = (surveyId) => {
      setExpandedComments(prev => ({
        ...prev,
        [surveyId]: !prev[surveyId]
      }));
    };

    const [submitting, setSubmitting] = useState(false);

    const menuRef = useRef(null);
    
    const formatDate = (dateString) => {
      if (!dateString) return "";
      return new Date(dateString).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    };
    
    useEffect(() => {
    const handleClickOutside = (event) => {
        if (menuRef.current && !menuRef.current.contains(event.target)) {
        setActiveToggleMenu(null);
        }
    };
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
        document.removeEventListener("mousedown", handleClickOutside);
    };
    }, []);

   
   const handleArchive = async (surveyId, surveyTitle) => {
        if (submitting) return;
        try {
            setSubmitting(true);
            const response = await archiveSurvey(surveyId);
            if (response && response.data && response.data.success) {
                setShowCloneModal(false);
                toast.success(
                  <div>
                    <div className="fw-bold">Survey Archived Successfully</div>
                    <div>{surveyTitle || "Survey"} has been moved to Archived Surveys.</div>
                    <button
                      type="button"
                      className="survey-toast-link bg-transparent p-0 mt-2"
                      onClick={() => onSwitchTab && onSwitchTab("archivedSurveys")}
                    >
                      View Archived Surveys
                    </button>
                  </div>
                );
                if (onSwitchTab) onSwitchTab("archivedSurveys");
                if (onRefresh) onRefresh();
            } else {
                toast.error(response.data.message || "Failed to archive survey");
            }
        } catch (error) {
            console.error("Error archiving survey:", error);
            toast.error("An error occurred while archiving the survey.");
        } finally {
            setSubmitting(false);
        }
    };


    const handleCloneSurvey = async () => {
        if (!selectedSurvey || submitting) return;
        try {
            setSubmitting(true);
            const response = await cloneSurvey(selectedSurvey.id);
            if (response && response.data && response.data.success) {
                setShowCloneModal(false);
                toast.success("Survey cloned successfully. A copy has been created in Drafts.");
                if (onSwitchTab) onSwitchTab("draftSurvey");
                if (onRefresh) onRefresh();
            } else {
                toast.error(response.data.message || "Failed to clone survey");
            }
        } catch (error) {
            console.error("Error cloning survey:", error);
            toast.error("An error occurred while cloning the survey.");
        } finally {
            setSubmitting(false);
        }
    };

    

   
    return (
        <>        

        {loading && surveys.length === 0 ? (
          <div className="d-flex justify-content-center my-4">
             <div className="spinner-border text-danger" role="status">
                <span className="visually-hidden">Loading...</span>
             </div>
          </div>
        ) : null}

        {surveys.map((item) => (
            <div className="sr-result-card mb-3" key={item.id}>            

                <div className="row g-3 align-items-center">
                    <div className="col-12 col-sm-auto">
                    <img src={survayimg1} className="rounded-4 border" style={{width: "70px", height: "64px", }} />
                    </div>

                    <div className="col-12 col-sm">
                        <div className="d-flex align-items-center justify-content-between gap-3">
                            <div>
                                <h2 className="sr-result-title">{item.survey_title}</h2> 
                                <p className="sr-result-copy mt-1">Last Response: {item.last_response_at || item.last_response_date ? formatDate(item.last_response_at || item.last_response_date) : Number(item.responses) > 0 ? "Date unavailable" : "No response yet"}</p>
                            </div>

                            <div className="d-flex gap-2 justify-content-md-end position-relative">

                            <div className="position-relative">                            
                                <div className={`user-status closed`}>
                                    {/* <span className="status-dot"></span> */}
                                    <span>Closed</span>
                                </div>
                            </div>

                            <button
                                type="button"
                                className="text-black border-0 bg-transparent"
                                onClick={() => setActiveToggleMenu(activeToggleMenu === item.id ? null : item.id)}
                            >
                                <MoreVertical size={20} />
                            </button>

                            {activeToggleMenu === item.id && (
                                <div className="cs-question-menu" ref={menuRef}>
                                <div className="d-flex gap-1 flex-column w-100">
                                        <button className="cs-action-link" onClick={() => {
                                             setSelectedSurvey(item);
                                             setShowCloneModal(true);
                                         }}>
                                            <CopyPlus size={16} />
                                            <span>Clone Survey</span>
                                        </button>

                                        <button className="cs-action-link" onClick={() => handleArchive(item.id, item.survey_title)}>
                                            <ArchiveRestore size={16} />
                                            <span>Archive</span>
                                        </button>
                                </div>
                                </div>
                            )}
                            </div>   

                        </div>
                    </div>  

                    <div className="col-12 mt-20 border-top pt20px">                    
                        <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-md-center gap-3">                        

                    <div className="d-flex w-100 align-items-center">
                                {(() => {
                                  const surveyLikesCount = item.like_count ?? item.likes_count ?? 0;
                                  const surveyCommentsCount = item.comment_count ?? item.comments_count ?? 0;
                                  return (
                                    <>
                                
                                <div className="flex-fill border-end px-2 px-sm-3">                        
                                    <div className="fw-bold ft-16 graytext">{item.responses || 0}</div>
                                    <div className="ft-12 color858c95" style={{ whiteSpace: "nowrap" }}>Responses</div>
                                </div>
                            
                                <div className="flex-fill border-end px-2 px-sm-3">                        
                                    <div className="fw-bold ft-16 graytext">{item.completion_rate || "0%"}</div>
                                    <div className="ft-12 color858c95" style={{ whiteSpace: "nowrap" }}>Completion Rate</div>
                                </div>
                            
                                <div className="flex-fill border-end px-2 px-sm-3">                        
                                    <div className="fw-bold ft-16 graytext">{item.view_count ?? item.views ?? 0}</div>
                                    <div className="ft-12 color858c95" style={{ whiteSpace: "nowrap" }}>Views</div>
                                </div>                            
                                
                                <div className="flex-fill border-end px-2 px-sm-3">                        
                                    <div className="d-flex align-items-center gap-2">
                                        <ThumbsUp size={16} className="text-secondary" style={{ flexShrink: 0 }} />
                                        <span className="fw-bold ft-16 graytext">{surveyLikesCount}</span>
                                    </div>
                                    <div className="ft-12 color858c95" style={{ whiteSpace: "nowrap" }}>Likes</div>
                                </div>                            

                                <div 
                                    className="flex-fill px-2 px-sm-3 sr-interactive-stats-col"
                                    onClick={() => {
                                      setSelectedSurvey(item);
                                      toggleComments(item.id);
                                    }}
                                >                        
                                    <div className="d-flex align-items-center gap-2">
                                        <MessageSquare size={16} className="text-secondary" style={{ flexShrink: 0 }} />
                                        <span className="fw-bold ft-16 graytext">{surveyCommentsCount}</span>
                                    </div>
                                    <div className="ft-12 color858c95" style={{ whiteSpace: "nowrap" }}>Comments</div>
                                </div>                            
                                    </>
                                  );
                                })()}
                            </div>  
                        
                            <div className="d-flex justify-content-center justify-content-sm-end w-100 w-sm-auto">
                                <RedButton
                                  btntext="View Responses"
                                  name="viewProfile"
                                  to={`/survey-results/${item.id}`}
                                  state={{ survey: item, tab: "responses" }}
                                />
                            </div>

                        </div>  
                    </div> 

                    {/* Live Comments Drawer Section */}
                    {expandedComments[item.id] && (
                      <div className="col-12">
                        <MySurveyCommentsThread
                          surveyId={item.id}
                          onViewAll={() => {
                            setEngagementModalTab("comments");
                            setSelectedSurvey(item);
                            setShowEngagementModal(true);
                          }}
                        />
                      </div>
                    )}
                </div> 
            </div>
        ))}





        {showCloneModal && (
            <div className="custom-modal-overlay">
                <div className="tw-w-full tw-max-w-[520px] tw-mx-4 bg-white rounded-4 p-5 position-relative text-center">

                <button
                    className="position-absolute top-0 end-0 border-0 bg-transparent fs-3 p-0 m-4"
                    onClick={() => setShowCloneModal(false)}
                >
                    <X size={22} />
                </button>

                <div className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-4 modal-icon" style={{ width: "60px", height: "60px", background: "#FDECEC", color: "#DC3545",}}>
                    <CopyPlus size={28} />
                </div>

                <h3 className="ft-24 fw-bold">Clone Survey</h3>

                <p className="fw-400 ft-16 graytext mt-12">
                    This will create a copy of this survey and save it to
                    <strong> Drafts.</strong> The original survey will remain unchanged.
                </p>

                <div className="d-flex gap-4 mt-18">
                    <button className="redhoverbtn w-100 ft-14 fw-bold text-black px-3 py-3 bgwhite rounded-2 cursor-target text-center border border-1 tw-transition-all tw-duration-300 tw-ease-in-out hover:tw-scale-105 w-50"
                    onClick={() => setShowCloneModal(false)}
                    >
                    Cancel
                    </button>

                    <button className="w-50 fw-bold ft-14 text-white px-5 py-3 bgred rounded-2 cursor-target text-center hover:tw-bg-[#333] tw-transition-all tw-duration-300 tw-ease-in-out hover:tw-scale-105 w-100"
                    onClick={handleCloneSurvey}
                    disabled={submitting}
                    >
                    {submitting ? "Cloning..." : "Clone Survey"}
                    </button>
                </div>

                </div>
            </div>
        )}

        {showEngagementModal && (
            <MySurveyEngagementModal
                surveyId={selectedSurvey?.id}
                activeTab={engagementModalTab}
                onTabChange={setEngagementModalTab}
                onClose={() => setShowEngagementModal(false)}
            />
        )}

        {hasMore && (
            <div className="d-flex justify-content-center my-4">
                <button
                    className="redhoverbtn px-4 py-2 bgwhite rounded-2 border border-1"
                    onClick={onLoadMore}
                    disabled={loading}
                >
                    {loading ? "Loading..." : "Load More"}
                </button>
            </div>
        )}

              
        </>
    );
};

export default ClosedSurvey;
